import React from 'react';
import { Col, Form, Input, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const areaStyles = {
  height: 150,
};

const DescriptionSection = () => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Descrizione')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Descrizione Attività')} name='description'>
          <Input.TextArea
            style={areaStyles}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(DescriptionSection);
